import {
    faBrain,
    faMicrophone,
    faUser,
    faTrophy,
    faBuildingColumns,
    faAddressBook
  } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MetaTags from "../../components/MetaTags";

export default function Contact() {
    return(
        <>
        <MetaTags 
            title="Contact"
            description="Ways to contact Alfonso Barajas Cervantes and chat"/>
        
        <div className="row ms-1 me-3 pb-5 text-start" id="wd-about">
            <div className="col-md-1 col-lg-2"></div>
            <div className="col-md-10 col-lg-8">
            <div className="text-center">
            <h2><FontAwesomeIcon icon={faAddressBook} className="small"/> Contact</h2>
            
            <strong>Email: </strong>barajasalfonso@outlook.com <br/>
            <strong>LinkedIn:</strong> Alfonso Barajas Cervantes @alfonsbc <br/>
            <strong>Website: </strong> alfonsobarajas.ai
            
            </div>
            </div>
            <div className="col-md-1 col-lg-2"></div>
        </div>
        </>
    );
}